import { useColors } from "../../../../hooks/colors/useColors";
import { Container } from "../../../UI/container/Container";
import { Grid } from "@mantine/core";
import { SpecialtyCard } from "./SpecialtyCard";
import { useTranslation } from "next-i18next";

export function Specialties() {
  const { colors } = useColors();
  const { t } = useTranslation("common");

  return (
    <div
      style={{
        backgroundColor: colors.background,
        overflow: "hidden",
        paddingBottom: 24,
      }}
    >
      <Container noHeight>
        <Grid justify="center" align="center" className="w-full">
          <Grid.Col
            span={{ base: 12, sm: 6, lg: 5 }}
            className="flex justify-center"
          >
            <SpecialtyCard
              href="/especialidades/psiquiatria"
              icon="https://wp.psiworks.pt/wp-content/uploads/2024/03/psiquiatria.png"
              title={t("specialties.psychiatry")}
              description={t("psychiatry-short-description")}
              image="https://wp.psiworks.pt/wp-content/uploads/2024/03/img-3.jpg"
            />
          </Grid.Col>
          <Grid.Col
            span={{ base: 12, sm: 6, lg: 5 }}
            className="flex justify-center"
          >
            <SpecialtyCard
              href="/especialidades/Psicoterapia-Analitica"
              icon="https://wp.psiworks.pt/wp-content/uploads/2024/03/image_2024-03-09_231229075.png"
              title={t("psychotherapy")}
              description={t("psychotherapy-short-description")}
              image="https://wp.psiworks.pt/wp-content/uploads/2024/03/image_2024-03-09_092537162.png"
            />
          </Grid.Col>
        </Grid>
      </Container>
    </div>
  );
}
